module.exports = "/images/laser tag (strokes).svg?91f0695353cd2c5f6e1c3a2230b8e625";